import { apiClient } from "../api"; // ✅ use our axios instance with .env support

// ✅ Fetch contact details
export const getContactInfo = async () => {
  const res = await apiClient.get("/contact");
  return res.data;
};

// ✅ Update contact details (Admin Panel)
export const updateContactInfo = async (data) => {
  const res = await apiClient.post("/contact", data);
  return res.data;
};

// ✅ Send message from contact form
export const sendContactMessage = async (payload) => {
  const res = await apiClient.post("/send-email", payload);
  return res.data;
};